export class GridNumber
{
  public value:number;
  public state:string;
  public numberType:string;
  public name:string = null;
  public badge:string;
}

export class LottolocaNumber
{
  public value:number;
  public name:string = null;
  public description = null;
}